export enum PtaConfigurationEnum {
    MODULE_ACCESS = 'View',
    PARTS_UPLOAD_ACCESS = 'NA',
    DUNS_UPLOAD_ACCESS = 'NA',
    SIGNOFF_UPLOAD_ACCESS = 'NA',
    PARTS_DOWNLOAD_ACCESS = 'NA',
    DUNS_DOWNLOAD_ACCESS = 'NA',
    SIGNOFF_DOWNLOAD_ACCESS = 'NA',
}
